export default __webpack_public_path__ + "static/media/logo.2ab858cf.jpg";